import { Button, Icon } from "@ttc3k/trekker";
import { Flex } from "styled-system/jsx";
import { useTranslation } from "react-i18next";
import { HtmlContent } from "shared/components/molecules/HtmlContent";
import { Lock } from "iconoir-react";

type BroadcastTeaserProps = {
  description: string;
  onCloseModal: () => void;
};

export const BroadcastTeaser = ({
  description,
  onCloseModal,
}: BroadcastTeaserProps) => {
  const { t } = useTranslation("home", {
    keyPrefix: "VIEWS.BROADCAST.VIEW_MODAL.ERROR",
  });

  return (
    <Flex
      w={"100%"}
      alignItems={"center"}
      justifyContent={"center"}
      flexDirection={"column"}
      gap={"400"}
      minH={"90vh"}
    >
      <Flex flexDirection={"column"} gap={"200"} alignItems={"center"}>
        <Icon Element={Lock} size="xl" color="icon.mid" />
      </Flex>

      <HtmlContent html={description} />

      <Flex gap={"150"} width={"full"}>
        <Button
          mode={"light"}
          size={"lg"}
          width={"full"}
          onClick={onCloseModal}
          type="button"
        >
          {t("BACK_TO_SITE")}
        </Button>
      </Flex>
    </Flex>
  );
};
